import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { FontsSignedCookiesAccess, SignedCookiesRepository } from '@efficiently/client-api-content';
import { GraphQLClient, GraphqlExecutorService } from '@efficiently/client-core-graphql';

import { GENERATE_FONTS_ASSETS_SIGNED_COOKIES } from '../graphql/queries';

@Injectable()
export class SignedCookiesGqlRepository extends SignedCookiesRepository {
	private readonly gql = inject(GraphqlExecutorService);

	public generateFontsAssetsSignedCookiesAccess(): Observable<FontsSignedCookiesAccess> {
		return this.gql.watchOnce(GENERATE_FONTS_ASSETS_SIGNED_COOKIES, {
			client: GraphQLClient.Identity,
			select: data => data.fontsAssetsSignedCookiesAccess,
		});
	}
}
